export const en = {
    'banners-max-selected': 'Select up to {maxCount} ads to edit',
    'banners-tab-name': 'Ads',
    'campaigns-tab-name': 'Campaigns',
    'export-to-excel-no-banners': "The campaign doesn't have any banners",
    'export-to-excel-no-banners-in-group': {
        one: "The group doesn't have any ads",
        some: "The groups don't have any ads",
        many: "The groups don't have any ads",
        none: "The groups don't have any ads"
    },
    'export-to-excel-tooltip': 'Export is only available within a single campaign',
    'feed-filters-tab-name': 'Feed filters',
    'groups-max-selected': 'Select up to {maxCount} ad groups to edit',
    'groups-tab-name': 'Groups',
    'phrases-tab-name': 'Keywords',
    'retargetings-tab-name': 'Retargeting & Audiences',
    'search-and-replace-forbidden-for-relevance-match': 'Search and replace are not supported for autotargeting',
    'select-campaigns': 'Choose campaigns',
    'targetings-tab-name': 'Impression criteria',
    'users-profile-tab-name': 'User profiles'
};
